module.exports = __webpack_public_path__ + "img/0.a3ea80b7.png";